import { SVGProps } from 'react';

const OfferAndContract = ({ props }: { props?: SVGProps<SVGSVGElement> }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="534" height="340" viewBox="0 0 534 340" fill="none" {...props}>
    <g clipPath="url(#old-clip)">
      <g filter="url(#old-blur)">
        <ellipse cx="208" cy="150.5" fill="#032B1F" rx="208" ry="150.5" transform="matrix(0 -1 -1 0 417 242)" />
      </g>
      <rect width="146.729" height="166.45" x="172" y="62" fill="url(#old-c)" rx="18.933" />
      <rect width="60.742" height="6.311" x="190.933" y="80.933" fill="#08935F" rx="3.155" />
      <rect width="41.021" height="6.311" x="215.388" y="95.921" fill="#08935F" rx="3.155" />
      <rect width="14.2" height="6.311" x="256.408" y="80.933" fill="#08935F" rx="3.155" />
      <rect width="14.2" height="6.311" x="225.643" y="110.909" fill="#08935F" rx="3.155" />
      <rect width="14.2" height="6.311" x="259.564" y="95.921" fill="#08935F" rx="3.155" />
      <rect width="41.021" height="6.311" x="190.933" y="157.452" fill="#08935F" rx="3.155" />
      <rect width="14.2" height="6.311" x="235.109" y="157.452" fill="#08935F" rx="3.155" />
      <rect width="21.299" height="6.311" x="252.464" y="157.452" fill="#08935F" rx="3.155" />
      <rect width="21.299" height="6.311" x="275.341" y="80.933" fill="#08935F" rx="3.155" />
      <rect width="31.555" height="6.311" x="190.933" y="110.909" fill="#08935F" rx="3.155" />
      <rect width="21.299" height="6.311" x="190.933" y="95.921" fill="#08935F" rx="3.155" />
      <rect width="11.044" height="6.311" x="190.933" y="142.464" fill="#08935F" rx="3.155" />
      <rect width="41.021" height="6.311" x="205.132" y="142.464" fill="#08935F" rx="3.155" />
      <rect width="14.2" height="6.311" x="249.309" y="142.464" fill="#08935F" rx="3.155" />
      <rect width="89.141" height="100.974" x="273.764" y="177.963" fill="url(#old-d)" rx="12.622" />
      <rect width="40.232" height="6.311" x="283.229" y="187.43" fill="#08935F" rx="3.155" />
      <rect width="26.821" height="6.311" x="299.796" y="202.418" fill="#08935F" rx="3.155" />
      <rect width="9.466" height="6.311" x="326.617" y="187.43" fill="#08935F" rx="3.155" />
      <rect width="9.466" height="6.311" x="306.107" y="217.406" fill="#08935F" rx="3.155" />
      <rect width="9.466" height="6.311" x="328.984" y="202.418" fill="#08935F" rx="3.155" />
      <rect width="14.2" height="6.311" x="339.239" y="187.43" fill="#08935F" rx="3.155" />
      <rect width="21.299" height="6.311" x="283.229" y="217.406" fill="#08935F" rx="3.155" />
      <rect width="14.2" height="6.311" x="283.229" y="202.418" fill="#08935F" rx="3.155" />
    </g>
    <defs>
      <linearGradient id="old-c" x1="312.13" x2="312.13" y1="62" y2="248.172" gradientUnits="userSpaceOnUse">
        <stop stopColor="#085D3F" />
        <stop offset="1" stopColor="#032B1F" />
      </linearGradient>
      <linearGradient id="old-d" x1="358.896" x2="358.896" y1="177.963" y2="290.901" gradientUnits="userSpaceOnUse">
        <stop stopColor="#39D08F" />
        <stop offset="1" stopColor="#084C36" />
      </linearGradient>
      <clipPath id="old-clip">
        <rect width="534" height="340" fill="#fff" rx="12.622" />
      </clipPath>
      <filter
        id="old-blur"
        width="701"
        height="816"
        x="-84"
        y="-374"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur result="effect1_foregroundBlur_186_1457" stdDeviation="100" />
      </filter>
    </defs>
  </svg>
);

export default OfferAndContract;
